export default from './comment-search-list-item';



// WEBPACK FOOTER //
// ./app/components/comment-search-list-item/index.js